import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';

import Permission from './index';

export function permissionFeature(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const isSimulation = PermissionClass.can(LIST_PERMISSION.SIMULATION);

  if (!isSimulation) {
    next({
      name: 'Dashboard'
    });
  }

  next();
}
